<template>
  <div>
    <v-card-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Filter"
      />
    </v-card-title>

    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          dark
          absolute
          top
          left
          @click.stop="onRefresh"
          v-on="on"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
      <span>Refresh</span>
    </v-tooltip>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :loading="isLoading"
      loading-text="Loading..."
      disable-initial-sort
    >
      <template
        slot="headers"
        slot-scope="props"
      >
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
          >
            {{ header.textHeader }}
            <br>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td class="text-center">
            {{ props.item.id }}
          </td>
          <td class="text-center">
            {{ props.item.name }}
          </td>
          <td class="text-center">
            {{ props.item.purpose }}
          </td>
          <td class="text-center">
            {{ iban(props.item) }}
          </td>
          <td class="text-center">
            {{ bic(props.item) }}
          </td>
          <td class="text-center">
            {{ props.item.tax_id }}
          </td>
          <td class="text-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  block
                  color="primary"
                  v-on="on"
                  @click.stop="() => setDebugCompany(props.item)"
                >
                  <v-icon
                    class="pr-2"
                  >
                    adb
                  </v-icon>
                </v-btn>
              </template>
              <span>Debug</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="secondary"
                  v-on="on"
                  @click.stop="() => showNvExportDialog(props.item.id)"
                >
                  NV
                </v-btn>
              </template>
              <span>Download exempted capital gains</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <DebugDialog
      :visible="isDebugDialogActive"
      :debug-object="debugObject"
      :title="debugTitle"
      @close="isDebugDialogActive = false"
    />
    <NvExportDialog
      :visible="nvExportDialog"
      :company-id="nvExportDialogId"
      :toggle-open="onNvExport"
    />
  </div>
</template>

<script>
import DebugDialog from '@/components/payoutsAndTaxes/payout/dialogs/shared/DebugDialog';
import NvExportDialog from '@/components/payoutsAndTaxes/payout/dialogs/company/NvExportDialog';

export default {
  name: 'Companies',
  components: {
    DebugDialog,
    NvExportDialog,
  },
  data() {
    return {
      isLoading: false,
      isCreating: false,
      isShowing: false,
      debugObject: {},
      debugTitle: '',
      isDebugDialogActive: false,
      pagination: {
        rowsPerPage: 25,
      },
      search: '',
      headers: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Name', value: 'name', align: 'center' },
        { text: 'Purpose', value: 'purpose', align: 'center' },
        { text: 'IBAN', value: 'iban', align: 'center' },
        { text: 'BIC', value: 'bic', align: 'center' },
        { text: 'Tax ID', value: 'tax_id', align: 'center' },
        { text: 'Actions', value: 'actions', align: 'center' },
      ],
      nvExportDialog: false,
      nvExportDialogId: '',
    };
  },
  computed: {
    items() {
      return this.$store.getters.getCompaniesList;
    },
    filteredItems() {
      const { search } = this;

      if (search.length < 1) {
        return this.items;
      }

      return this.items.filter((item) => {
        let found = false;
        Object.keys(item)
          .map((key) => {
            if (item[key] && String(item[key]).toLowerCase().indexOf(search.toLowerCase()) > -1) {
              found = true;
            }

            return key;
          });

        return found;
      });
    },
  },
  mounted() {
    this.onRefresh();
  },
  methods: {
    onRefresh() {
      this.$store.dispatch('fetchPatCompanyAll');
    },
    setDebugCompany(company) {
      this.debugObject = company;
      this.debugTitle = 'Debug Company Information';
      this.isDebugDialogActive = true;
    },
    getBankAccounts(company) {
      return company.bank_accounts
        ? company.bank_accounts.filter(item => item.account_type === 'Business' || item.account_type === '0') : null;
    },
    iban(company) {
      const bankAccounts = this.getBankAccounts(company);

      return bankAccounts && bankAccounts.length > 0 ? bankAccounts[0].iban : '-';
    },
    bic(company) {
      const bankAccounts = this.getBankAccounts(company);

      return bankAccounts && bankAccounts.length > 0 ? bankAccounts[0].bic : '-';
    },
    showNvExportDialog(id) {
      this.nvExportDialogId = id;
      this.nvExportDialog = true;
      this.$forceUpdate();
    },
    onNvExport() {
      this.nvExportDialog = !this.nvExportDialog;
    },
  },
};
</script>
<style lang="scss">
.text-center {
  text-align: center;
}

.mass-create {
  margin-right: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/Companies.vue